export const UPDATE_COURSE_INFO = 'UPDATE_COURSE_INFO';

export const RESET_COURSE_INFO = 'RESET_COURSE_INFO';

export const POST_NEW_COURSE = 'POST_NEW_COURSE';

export const POST_NEW_COURSE_SUCCESS = 'POST_NEW_COURSE_SUCCESS';

export const POST_NEW_COURSE_FAIL = 'POST_NEW_COURSE_FAIL';
